import fly from '@/flyio';
declare let process: any;
import { AppUtil } from '../utils/app.util';
import { CryptoUtil } from '../utils/crypto.util';
import { Constants } from '../const/Constants';
import { LocalStorageService, CookieService } from './storageService';
// import { UserInfo } from '../types/user.info';
export default {
	appInfoAtiak: process.env.VUE_APP_INFO_ATIAK,
	eKey: 'sxyyd@2022^&*()%',
	userInfoKey: Constants.Cookie.User + '_' + AppUtil.getFirstHost(),
	getEKey(): string {
		return this.eKey;
	},
	getToken(atiak: string) {
		return fly.get(process.env.VUE_APP_BASE_API_USER + '/caccount/token?atiak=' + atiak);
	},

	// 发送验证码
	sendCode(check: number, phone?: string) {
		if (phone && phone != null && phone.length > 0) {
			return fly.put(process.env.VUE_APP_BASE_API_CAHD + '/user/code/sms/' + phone, { check: check });
		} else {
			return fly.put(process.env.VUE_APP_BASE_API_CAHD + '/user/smsCode', { check: check });
		}
	},

	// 手机号重复绑定账号校验
	userMobileBindList(mobile?: string, smsCode?: string, registerName?: string) {
		const param: any = {};
		if (mobile && smsCode) {
			param.mobile = mobile;
			param.smsCode = smsCode;
		}
		if (registerName) param.registerName = registerName;
		return fly.post(process.env.VUE_APP_BASE_API_USER + '/caccount/mobile/bind/list', param, {
			headers: { 'Content-Type': 'application/json;charset=UTF-8' },
		});
	},

	// 账号密码手机号绑定注册
	registerBind(userName: string, password: string, atiak: string, mobile: string, smsCode: string) {
		const random = AppUtil.getRandomNumStr(6);
		return fly.post(process.env.VUE_APP_BASE_API_USER + '/caccount/register/bind/' + random + '?atiak=' + atiak, CryptoUtil.encrypt({ loginName: userName, password: password, mobile, smsCode }, CryptoUtil.generateApiKey(random)), {
			headers: { 'Content-Type': 'application/json;charset=UTF-8', Accept: 'application/json,text/plain,*/*' },
		});
	},
	// 三端统一基础登录接口（账号密码登录+手机号验证码登录）
	// 账号: "loginName":"2c的小李","password":"qq@123456","loginNameType":"USERNAME"
	// 验证码: "loginName":"17770287579","smsCode":"123456","loginNameType":"MOBILE"
	caccountLogin(params: { atiak: string; loginNameType: string; loginName: string; password?: string; smsCode?: string }) {
		const random = AppUtil.getRandomNumStr(6);
		return fly.post(process.env.VUE_APP_BASE_API_USER + '/caccount/login/' + random, CryptoUtil.encrypt(params, CryptoUtil.generateApiKey(random)), {
			headers: { 'Content-Type': 'application/json;charset=UTF-8' },
		});
	},

	generateAutoLoginInfo(data: any) {
		try {
			let userInfo: any = { account: { accoAccess: {} } };
			userInfo.account.account = data.result.account.account;
			userInfo.token = data.result.token;
			userInfo.openId = data.result.openId;
			userInfo.is2C = data.result.is2C;
			userInfo.expired = data.result.expired;
			userInfo.isRandom = data.result.isRandom;
			userInfo.account.nick = data.result.account.nick;
			userInfo.nick = data.result.account.nick;
			userInfo.is2CUser = data.result.is2C ? true : false;
			userInfo.userName = data.result.userName;
			const accoAccess = data.result.account.accoAccess;
			if (accoAccess && AppUtil.isNotEmpty(accoAccess) && accoAccess.mobile && AppUtil.isNotEmpty(accoAccess.mobile)) {
				userInfo.account.accoAccess.mobile = accoAccess.mobile;
			}

			if (data.result.account.baseInfo) {
				userInfo.avatarUrl = data.result.account.baseInfo.avatarUrl ? data.result.account.baseInfo.avatarUrl : '';
				userInfo.birthday = data.result.account.baseInfo.birthdayStr ? data.result.account.baseInfo.birthdayStr : '';
				userInfo.gender = data.result.account.baseInfo.gender ? data.result.account.baseInfo.gender : '';
				userInfo.name = data.result.account.baseInfo.name ? data.result.account.baseInfo.name : '';
				userInfo.email = data.result.account.baseInfo.email ? data.result.account.baseInfo.email : '';
			}
			//个人拓展信息
			if (data.result.accountExtInfo) {
				userInfo.accountExtInfo = data.result.accountExtInfo;
			} else {
				userInfo.accountExtInfo = [];
			}
			if (data.result.displayName) {
				userInfo.displayName = data.result.displayName;
			}

			if (data.result.logo) {
				userInfo.logo = data.result.logo;
			}
			// 支付相关
			if (data.result.payType) {
				userInfo.payType = data.result.payType;
			} else {
				userInfo.payType = 'self';
			}

			const loginInfo = AppUtil.encodeBase64(JSON.stringify(userInfo));
			// 存入cookie
			const expireDate: Date = new Date();
			expireDate.setSeconds(expireDate.getSeconds() + 30);
			CookieService.set(Constants.Cookie.Auth_Info, loginInfo, {
				path: '/',
				domain: '.chineseall.cn',
        expires: expireDate,
			});

			this.updateCookieUser(userInfo);
			return userInfo;
		} catch (e) {
			console.error(e);
		}
		return null;
	},
	// 保存登录用户信息
	saveLoginedInfo(data: any, issso: boolean): boolean {
		try {
			if (AppUtil.isObject(data) && data.result) {
				let userInfo: any = {};
				userInfo.account = data.result.account.account;
				userInfo.nick = data.result.account.nick;
				userInfo.token = data.result.token;
				userInfo.openId = data.result.openId;
				userInfo.issso = issso;
				userInfo.is2CUser = data.result.is2C ? true : false;
				userInfo.expired = data.result.expired;
				userInfo.userName = data.result.userName;
				//console.log("data.result.accountExtinfo:", data.result.accountExtInfo)
				// 这里暂时兼容单点登录参数结构不匹配的bug
				userInfo.avatarUrl = data.result.avatarUrl;
				userInfo.birthday = data.result.birthday;
				userInfo.gender = data.result.gender;
				userInfo.name = data.result.name;
				userInfo.email = data.result.email;
				if (data.result.account.baseInfo) {
					userInfo.avatarUrl = data.result.account.baseInfo.avatarUrl ? data.result.account.baseInfo.avatarUrl : '';
					userInfo.birthday = data.result.account.baseInfo.birthdayStr ? data.result.account.baseInfo.birthdayStr : '';
					userInfo.gender = data.result.account.baseInfo.gender ? data.result.account.baseInfo.gender : '';
					userInfo.name = data.result.account.baseInfo.name ? data.result.account.baseInfo.name : '';
					userInfo.email = data.result.account.baseInfo.email ? data.result.account.baseInfo.email : '';
				}

				//个人拓展信息
				if (data.result.accountExtInfo) {
					userInfo.accountExtInfo = data.result.accountExtInfo;
				} else {
					userInfo.accountExtInfo = [];
				}
				if (data.result.displayName) {
					userInfo.displayName = data.result.displayName;
				}

				if (data.result.logo) {
					userInfo.logo = data.result.logo;
				}
				const accoAccess = data.result.account.accoAccess;
				if (accoAccess && AppUtil.isNotEmpty(accoAccess) && accoAccess.mobile && AppUtil.isNotEmpty(accoAccess.mobile)) {
					userInfo.mobile = accoAccess.mobile;
				}
				// 支付相关
				if (data.result.payType) {
					userInfo.payType = data.result.payType;
				} else {
					userInfo.payType = 'self';
				}
				this.saveCookieUser(userInfo);
				return true;
			} else {
				return false;
			}
		} catch (e) {
			console.error(e);
			return false;
		}
	},
	getLoginedUser() {
		let user = this.getCookieUser();
		if (AppUtil.isEmpty(user) || AppUtil.isEmpty(user.account)) {
			return null;
		} else {
			return user;
		}
	},
	saveCookieUser(userInfo: any) {
		this.removeCookieUser();
		if (!userInfo.expired) {
			userInfo.expired = 7 * 24 * 60 * 60 * 1000;
		}
		if (AppUtil.isEmpty(userInfo.nick)) {
			delete userInfo.nick;
		} else {
			userInfo.nick = encodeURIComponent(userInfo.nick);
		}
		if (AppUtil.isEmpty(userInfo.userName)) {
			delete userInfo.userName;
		} else {
			userInfo.userName = userInfo.userName;
		}
		const expiredAt = Math.floor((userInfo.expired - new Date().getTime()) / 1000);
		LocalStorageService.set(this.userInfoKey, CryptoUtil.encrypt(userInfo, this.getEKey()), expiredAt);
	},
	updateCookieUser(userInfo: any) {
		if (!userInfo.expired) {
			console.error('expired is null');
			return;
		}
		this.removeCookieUser();
		userInfo.nick = encodeURI(userInfo.nick);
		const expiredAt = Math.floor((userInfo.expired - new Date().getTime()) / 1000);
		LocalStorageService.set(this.userInfoKey, CryptoUtil.encrypt(userInfo, this.getEKey()), expiredAt);
	},
	getCookieUser() {
		let userInfoStr = LocalStorageService.get(this.userInfoKey);
		if (AppUtil.isNotEmpty(userInfoStr)) {
			try {
				let userInfoCache = CryptoUtil.decrypt(userInfoStr, this.getEKey());
				if (userInfoCache.name) {
					userInfoCache.name = decodeURIComponent(userInfoCache.name);
				}
				if (userInfoCache.nick) {
					userInfoCache.nick = decodeURIComponent(userInfoCache.nick);
				}
				return userInfoCache;
			} catch (err) {
				this.removeCookieUser();
				console.error(err);
			}
		}
		return null;
	},
	removeCookieUser() {
		LocalStorageService.remove(this.userInfoKey);
	},
	loginOut() {
		return fly.delete(process.env.VUE_APP_BASE_API_USER + '/caccount/logout');
	},

	updateUserInfo(userInfo: any) {
		return fly.post(process.env.VUE_APP_BASE_API_CAHD + '/user/edit', userInfo);
	},
	getVisitorsToken(atiak: string) {
		return fly.get(process.env.VUE_APP_BASE_API_USER + '/caccount/token?atiak=' + atiak);
	},
	saveVisitorsToken(token: string, expired: number): boolean {
		let user: any = {};
		user.token = token;
		user.expired = expired;
		this.saveCookieUser(user);
		return true;
	},
	initVisitorsToken(atiak: string) {
		return new Promise((resolve, reject) => {
			this.getVisitorsToken(atiak).then((data: any) => {
				if (data && data.success && AppUtil.isNotEmpty(data.result.token)) {
					this.saveVisitorsToken(data.result.token, data.result.expired);
					resolve(data);
				} else {
					resolve({ success: false });
				}
			});
		});
	},
	updatePaswordByMobile(phone: string, smsCode: string, passwd: string) {
		return fly.post(process.env.VUE_APP_BASE_API_CAHD + '/user/mobile/resetPasswd', { mobile: phone, code: smsCode, newPassword: passwd });
	},
	updatePasword(newPassword: string, oldPassword: string) {
		return fly.post(process.env.VUE_APP_BASE_API_CAHD + '/user/edit', { newPassword: newPassword, oldPassword: oldPassword });
	},
};
